import { type TFunction } from 'i18next';
import { type Guide } from './guide';

export interface MarkdownOptions {
  /** Resolves app-relative links, since the file is read outside the app. */
  origin: string;
  t: TFunction;
}

export const toMarkdown = (
  guide: Guide,
  { origin, t }: MarkdownOptions
): string => {
  const lines: string[] = [];

  lines.push(`# ${guide.title}`, '', guide.intro);

  if (guide.summary && guide.summary.length > 0) {
    lines.push(
      '',
      guide.summary.map(({ label, value }) => `${label}: ${value}`).join(' · ')
    );
  }

  guide.sections.forEach((section, index) => {
    lines.push('', `## ${index + 1}. ${section.heading}`, '', section.body);

    if (section.link) {
      const href = new URL(section.link.href, origin).href;
      lines.push('', `[${section.link.text}](${href})`);
    }

    for (const block of section.blocks) {
      lines.push(
        '',
        `**${block.label}**`,
        '',
        `\`\`\`${block.language}`,
        block.code,
        '```'
      );
    }

    if (section.note) {
      lines.push('', `**${t('Note:')}** ${section.note}`);
    }
  });

  if (guide.footer) {
    lines.push('', guide.footer);
  }

  return lines.join('\n');
};
